'use strict';

/* global $ */

function Header(options) {

    let opt = $.extend(true, {
    }, options);

    function initBlock(el) {
        let $el = $(el);

        console.log('[ Header/Init ]');

        opt = $.extend({
            fixed: 'is-fixed',
            button: '.js-top',
            show: 'is-show'
        }, opt);

        $(window).on('scroll', function(e) {
            let add = false;
            let addtop = false;
            if (window.pageYOffset > 0) {
                add = true;
            }
            if (add) {
                $el.addClass(opt.fixed);
            } else {
                $el.removeClass(opt.fixed);
            }
            if (window.pageYOffset > window.innerHeight / 2) {
                addtop = true;
            }
            if (addtop) {
                $(opt.button).addClass(opt.show);
            } else {
                $(opt.button).removeClass(opt.show);
            }
        });

        /*
        $(opt.button).on('click', function() {
            $('html, body').animate({ scrollTop: 0 }, 1000);
        });
        */
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Header
};
